import React, { useEffect, useRef, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';

function SiteHeader() {
  const railRef = useRef(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    let frame = 0;

    const update = () => {
      frame = 0;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? window.scrollY / scrollable : 0;
      if (railRef.current) {
        railRef.current.style.setProperty('--progress', String(Math.min(1, Math.max(0, progress))));
      }
      setIsStuck(window.scrollY > 12);
    };

    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <header className={`App-header${isStuck ? ' is-stuck' : ''}`}>
      <h1>
        <Link
          to="/"
          className="logo-container"
          onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
        >
          <img src="images/databuilder-icon.svg" alt="Databuilder Limited" className="logo-image" />
          <span>
            Databuilder<span className="logo-dot">.</span>
          </span>
        </Link>
      </h1>
      <ul className="nav-links">
        <li>
          <NavLink
            to="/epc"
            exact
            activeClassName="current-page"
            onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
          >
            EPC Complete
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/consultancy"
            exact
            activeClassName="current-page"
            onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
          >
            Consultancy
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/agents"
            exact
            activeClassName="current-page"
            onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
          >
            Agentic AI
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            exact
            activeClassName="current-page"
            onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
          >
            About
          </NavLink>
        </li>
      </ul>
      <span className="scroll-rail" ref={railRef} aria-hidden="true" />
    </header>
  );
}

export default SiteHeader;